import {ref} from 'vue';
import ApiService from "@services/ApiService";
import {isMobileDevice} from "@utils/isMobileDevice";

export function useGame() {
    const game = ref(0);
    const demo = ref(0);
    const isLoading = ref(false);
    const isGameLoaded = ref(false);
    const seo = useState('seo');

    /**
     * Fetch game data
     *
     * @param demoValue
     * @param id The id of game
     */
    async function fetchGameData(demoValue: number, id: number) {
        isLoading.value = true;
        isGameLoaded.value = false;

        const {data} = await ApiService.get(
            `/api/casino-games/${id}/start?demo=${demoValue}&isMobileDevice=${
                isMobileDevice() ? 1 : 0
            }`,
        );

        isLoading.value = false;
        return data;
    }

    return {
        game,
        seo,
        demo,
        isLoading,
        isGameLoaded,
        fetchGameData
    };
}